import { Segment } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledSegment = styled(Segment)`
background: white !important;
-webkit-box-shadow: none !important;
background-color: rgb(241 245 249) !important;
border: none !important;
border-radius: 1.3rem !important;
box-shadow: none !important;
padding: 15px;
min-height: auto !important;
padding-bottom: 15px !important;
 .column {
  -webkit-box-shadow: none !important;  
   box-shadow: none !important;
 }
 .header {
  margin-top: -1em !important;
  padding: 2rem 0rem 0rem 1rem !important;
  font-size: 18px !important;
 }
 .row {
  flew-wrap: no-wrap !important;
 }
`